import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {WebSocketService} from '../../../../../core/service/web-socket-service';
import {AuthService} from '../../../../../core/service/auth.service';
import {VnaPortalService} from '../../services/vna-portal.service';

@Component({
  selector: 'app-test-portal-service',
  templateUrl: './test-portal-service.component.html',
  styleUrls: ['./test-portal-service.component.scss']
})
export class TestPortalServiceComponent extends ModalExtended implements OnInit {

    formData: FormGroup;
    errors: Object = {};
    submitted: boolean = false;

    data: Object = {};

    phoneResponse: Object = {};
    enabled: boolean = false;

    onExit(): void {
        this.applyCallback('');
        this.close();
    }

    constructor(private ws: WebSocketService, private portalHandler: VnaPortalService) {
        super();
        this.formData = new FormGroup({
            element: new FormControl('', Validators.required),
            lang: new FormControl('', Validators.required),
            use_cache: new FormControl('0'),
        });
    }

    testPhone(): void {
        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.enabled = true;
        var formValues = Object.assign({}, this.formData.value);
        this.portalHandler
            .getTestService(this.data['portal_pk'], this.data['service_pk'], formValues)
            .subscribe(
                (r) => {
                    if(r.hasOwnProperty('errors')){
                        this.errors = r.errors;
                    }
                    else{
                        if(r.status != 'CALLBACK_PENDANT'){
                            this.phoneResponse = { 'status' : r.full_status, 'service_response' : r.provider_msg };
                            this.enabled = false;
                        }
                    }
                }
            )
    }

    ngOnInit() {
        this.ws.message.subscribe(
            (msg: Object) => {
                if(msg.hasOwnProperty('type') && msg['type'] == 'vna_phone_test_verification'){
                    let element = this.formData.value.element.replace(/\//g, "");
                    let receivedElement = msg['element'].replace(/\//g, "");
                    let regex = new RegExp(receivedElement);

                    if(element === receivedElement || element.match(regex)){
                        this.phoneResponse = msg['response'];
                        this.enabled = false;
                    }
                }
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/components/test-portal-service/test-portal-service.component.ts